module.exports = __webpack_public_path__ + "static/mnews02.png";